import FacebookPage from '@/pages/FacebookPage/FacebookPage';

export default FacebookPage;
